import React, { useState } from 'react'
import PropTypes from 'prop-types';
import "../../css/pages/faqspage.css";



function Accordion({ option, id }) {

    const head = () => {
        return (
            <div className="c-accordion__header  js-accordion__title" id={"head-" + id}>
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                    <button id={"head-button-" + id} className="c-accordion__title-label  js-accordion__title-label" aria-expanded="false" type="button">
                        <span className="c-accordion__title-label-text" dangerouslySetInnerHTML={{ __html: option.Head }}>

                        </span>
                    </button>
                </h3>
            </div>
        )
    }

    const body = () => {
        return (
            <div className="c-accordion__panel  js-accordion__panel" aria-hidden=" true " id={"body-content-" + id}>
                <div className="c-accordion__content" id={"content-" + id} dangerouslySetInnerHTML={{ __html: option.Body }}>
                </div>
            </div >
        )
    }

    return (
        <div className="c-accordion  js-accordion  js-is-fx  c-accordion--bg-panel" id={id}>
            {head()}
            {body()}
        </div>
    )
}
export default Accordion